/* esm.sh - esbuild bundle(@tanstack/react-table@8.9.1) denonext production */
import*as r from"/stable/react@18.2.0/denonext/react.mjs";import{createTable as s}from"/v127/@tanstack/table-core@8.9.1/denonext/table-core.mjs";export*from"/v127/@tanstack/table-core@8.9.1/denonext/table-core.mjs";function y(t,e){return t?f(t)?r.createElement(t,e):t:null}function f(t){return i(t)||typeof t=="function"||l(t)}function i(t){return typeof t=="function"&&(()=>{let e=Object.getPrototypeOf(t);return e.prototype&&e.prototype.isReactComponent})()}function l(t){return typeof t=="object"&&typeof t.$$typeof=="symbol"&&["react.memo","react.forward_ref"].includes(t.$$typeof.description)}function R(t){let e={state:{},onStateChange:()=>{},renderFallbackValue:null,...t},[n]=r.useState(()=>({current:s(e)})),[o,c]=r.useState(()=>n.current.initialState);return n.current.setOptions(u=>({...u,...t,state:{...o,...t.state},onStateChange:a=>{c(a),t.onStateChange==null||t.onStateChange(a)}})),n.current}export{y as flexRender,R as useReactTable};
/*! Bundled license information:

@tanstack/react-table/build/lib/index.mjs:
  (**
   * react-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   *)
*/
//# sourceMappingURL=react-table.mjs.map